import { render } from "./ProfileDonations.vue?vue&type=template&id=04b915d8"
import script from "./ProfileDonations.vue?vue&type=script&lang=js"
export * from "./ProfileDonations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__